"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultListYourPropertySuccessCases = exports.defaultListYourPropertySuccessCase = void 0;
exports.defaultListYourPropertySuccessCase = {
    image: 'https://ww2.okay.com/commoncontent/images/listproperty/successroute/sold-century-tower.jpg',
    building: 'Century Tower',
    price: 55000000
};
exports.defaultListYourPropertySuccessCases = [
    exports.defaultListYourPropertySuccessCase,
    exports.defaultListYourPropertySuccessCase,
    exports.defaultListYourPropertySuccessCase,
    exports.defaultListYourPropertySuccessCase
];
